import { render, staticRenderFns } from "./LPTextCardSlider.vue?vue&type=template&id=b7be6310"
import script from "./LPTextCardSlider.vue?vue&type=script&lang=js"
export * from "./LPTextCardSlider.vue?vue&type=script&lang=js"
import style0 from "./LPTextCardSlider.vue?vue&type=style&index=0&id=b7be6310&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports